'use strict';

function DashController (OrganizationStore, $scope) {
  /* custom logo */
  $scope.brandConfig = OrganizationStore.getBrandConfig()
  /* /custom logo */
}

DashController.$inject = ['OrganizationStore', '$scope'];
module.exports = DashController;



// WEBPACK FOOTER //
// ./src/app/dash/DashController.js